const firmware = {
  firmware: 'Firmware',
  add_firmware: 'New Firmware',
  product_code: 'Product Code',
  version: 'Version',
  mandatory: 'Mandatory',
  launch: 'Launch',
  launched: 'Launched',
  not_launched: 'Not launched',
  add_success_msg: 'Firmware added successfully',
  update_success_msg: 'Firmware updated successfully',
  firmware_deleted: 'Firmware deleted',
  update_firmware: 'Update Firmware',
  upload_firmware: 'Upload Firmware',
  install_firmware: 'Install Firmware',
  select_firmware_msg: 'Select the firmware to install and press Continue',
  confirm_update_msg:
    'Are you sure you want to install firmware version {{version}} on Controller {{controller}}?',
  confirm_update_r_msg:
    'Are you sure you want to install firmware version {{version}} on Reader {{reader}}?',
  firmware_error_title: 'Firmware Error',
  error_learn_more: 'Error - Learn More',
  drag_drop: 'Drag and drop your file here or',
  upload_a_file: 'Upload a file',
  table: {
    date: 'Date',
    controller: 'Controller',
    reader: 'Reader',
    release: 'Realease note',
  },
};

export default firmware;
